import axios from '../../bootstrap';

/**
 * @param {{ post_name: any; save_img: number; incat: any[]; pricat: string; }} odjData
 */
export function axiosBlogCreatePost(odjData) {
    return axios.post('/api/admin/blog/createpost', odjData);
}

/**
 * @param {{ slug_id: any; }} odjData
 */
export function axiosBlogSetHide(odjData) {
    return axios.post('/api/admin/blog/sethide', odjData);
}
